import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ArrayCountWidget: WidgetRegistryEntry = {
  name: "ArrayCount",
  configuration: () => import("./configuration").then((m) => m.ArrayCountWidgetConfiguration),
  component: () => import("./array-count-widget.component").then((m) => m.ArrayCountWidgetComponent)
};
